/**
 * AUTO-GENERATED by scripts/estate-planning/generateMockTemplateSources.mjs
 * Source: estate-client-schemas/templates/*.json
 * Do not edit by hand — re-run the generator after schema template updates.
 */
import type {EstateTemplateBody} from './composeEstateFlowTemplate';

export const ABOUT_YOU_TEMPLATE = {
  sections: [
    {
      id: 'section_getting_started',
      title: 'Getting started',
      steps: [
        {
          id: 'step_confirm_info',
          component: 'itemList',
          bodyTitle: "Before we start, let's confirm the info we have about you is right",
          answerKey: 'answerResponse.testator.profile',
          prefillSource: 'prefillSource.testator.profile',
          items: [
            {
              type: 'static',
              icon: 'person',
              value: '${prefillSource.testator.profile.name.fullName}',
              label: 'Full legal name',
              ctaText: 'Edit',
              ctaTrigger: 'modal_edit_name',
              answerKey: 'answerResponse.testator.profile.name',
            },
            {
              type: 'static',
              icon: 'house',
              value:
                '${prefillSource.testator.profile.address.address}${? ${prefillSource.testator.profile.address.address2}}, ${prefillSource.testator.profile.address.city}, ${prefillSource.testator.profile.address.state}, ${prefillSource.testator.profile.address.zip}',
              label: 'Primary address',
              ctaText: 'Edit',
              ctaTrigger: 'modal_edit_address',
              answerKey: 'answerResponse.testator.profile.address',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_confirm_primary_address',
          component: 'binaryChoice',
          bodyTitle: 'Is this your primary address?',
          bodySubtitle:
            '${prefillSource.testator.profile.address.address}${? ${prefillSource.testator.profile.address.address2}}, ${prefillSource.testator.profile.address.city}, ${prefillSource.testator.profile.address.state}, ${prefillSource.testator.profile.address.zip}',
          answerKey: 'answerResponse.testator.primaryAddressConfirmed',
          prefillSource: 'prefillSource.testator.primaryAddressConfirmed',
          choices: [
            {
              label: 'No',
              value: 'false',
              ctaTrigger: 'modal_edit_address',
              answerKey: 'answerResponse.testator.profile.address',
            },
            {
              label: 'Yes',
              value: 'true',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_getting_started_intro',
          component: 'sectionReview',
          bodyTitle: "Here's an overview of what to expect",
          bodySubtitle:
            "We'll walk you through step-by-step and prefill what we can so you can focus on what matters most.",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
  addressStateGate: {
    id: 'step_address_state_gate',
    component: 'addressStateGate',
    icon: 'house',
    bodyTitle: "Estate planning isn't available in your state yet",
    banner: {
      title: "We're working on it",
      subtitle:
        "We'll be in ${testator.profile.address.state} soon. In the meantime, our support team can answer any questions.",
    },
    items: [
      {
        type: 'static',
        icon: 'house',
        value:
          '${prefillSource.testator.profile.address.address}${? ${prefillSource.testator.profile.address.address2}}, ${prefillSource.testator.profile.address.city}, ${prefillSource.testator.profile.address.state}, ${prefillSource.testator.profile.address.zip}',
        label: 'Primary address',
        ctaText: 'Edit',
        ctaTrigger: 'modal_edit_address',
        answerKey: 'answerResponse.testator.profile.address',
      },
    ],
    primaryCta: {
      label: 'Contact support',
      ctaTrigger: 'contact_support',
    },
    secondaryCta: {
      label: 'Back to dashboard',
      ctaTrigger: 'navigate_to_dashboard',
    },
  },
} as EstateTemplateBody;

export const FAMILY_TEMPLATE = {
  sections: [
    {
      id: 'section_family',
      title: 'Personal & Family',
      steps: [
        {
          id: 'step_relationship_status',
          component: 'radioList',
          bodyTitle: "What's your relationship status?",
          bodySubtitle:
            "This shapes who can inherit, and who's automatically involved in your ${prefillSource.packageType}.",
          answerKey: 'answerResponse.testator.relationshipStatus',
          prefillSource: 'prefillSource.testator.relationshipStatus',
          options: [
            {
              value: 'single',
              title: 'Single',
              subtitle: "You're not legally married",
            },
            {
              value: 'married',
              title: 'Married',
              subtitle: 'You have a spouse or registered partner',
            },
            {
              value: 'divorced',
              title: 'Divorced',
              subtitle: 'Your marriage has legally ended',
            },
            {
              value: 'widowed',
              title: 'Widowed',
              subtitle: 'Your spouse has passed away',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_confirm_spouse',
          component: 'binaryChoice',
          bodyTitle: 'We found ${prefillSource.testator.spouse.fullName} on your account. Is this your spouse?',
          bodySubtitle: "If so, we can pre-fill ${prefillSource.testator.spouse.firstName}'s info for you.",
          answerKey: 'answerResponse.testator.spouseConfirmed',
          prefillSource: 'prefillSource.testator.spouseConfirmed',
          showWhen: {
            operator: 'and',
            conditions: [
              {
                answerKey: 'answerResponse.testator.relationshipStatus',
                operator: 'equals',
                value: 'married',
              },
              {
                storeKey: 'prefillSource.testator.spouse',
                operator: 'notEmpty',
              },
            ],
          },
          choices: [
            {
              label: 'No',
              value: 'false',
              subtitle: 'not my spouse',
            },
            {
              label: 'Yes',
              value: 'true',
              subtitle: '${prefillSource.testator.spouse.firstName} is my spouse',
              storeSource: 'prefillSource.testator.spouse',
              saveTo: 'answerResponse.testator.spouse',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_details_confirm',
          component: 'multiInput',
          bodyTitle: "Confirm ${testator.spouse.firstName}'s details",
          bodySubtitle:
            "Review ${testator.spouse.firstName}'s full legal name and birthday as listed on their birth certificate, driver's license, or passport.",
          answerKey: 'answerResponse.testator.spouse',
          prefillSource: 'prefillSource.testator.spouse',
          showWhen: {
            operator: 'and',
            conditions: [
              {
                answerKey: 'answerResponse.testator.relationshipStatus',
                operator: 'equals',
                value: 'married',
              },
              {
                answerKey: 'answerResponse.testator.spouseConfirmed',
                operator: 'equals',
                value: 'true',
              },
            ],
          },
          fields: [
            {
              id: 'firstName',
              fieldName: 'First name',
              inputType: 'text',
              validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid first name using letters only',
            },
            {
              id: 'middleName',
              fieldName: 'Middle name (optional)',
              inputType: 'text',
              validation: "^$|^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid middle name',
            },
            {
              id: 'lastName',
              fieldName: 'Last name',
              inputType: 'text',
              validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid last name using letters only',
            },
            {
              id: 'dateOfBirth',
              fieldName: 'Date of birth (mm/dd/yyyy)',
              inputType: 'date',
              validation: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
              validationMessage: 'Enter a valid date in mm/dd/yyyy format',
              minAge: 18,
            },
            {
              id: 'email',
              fieldName: 'Email (optional)',
              inputType: 'email',
              validation: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
              validationMessage: 'Enter a valid email address',
            },
          ],
          requiredFields: ['firstName', 'lastName', 'dateOfBirth'],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_details',
          component: 'multiInput',
          bodyTitle: "What's your spouse's name and birthday?",
          bodySubtitle:
            "Your spouse's full legal name and birthday as listed on their birth certificate, driver's license, or passport.",
          answerKey: 'answerResponse.testator.spouse',
          prefillSource: 'prefillSource.testator.spouse',
          showWhen: {
            operator: 'and',
            conditions: [
              {
                answerKey: 'answerResponse.testator.relationshipStatus',
                operator: 'equals',
                value: 'married',
              },
              {
                operator: 'or',
                conditions: [
                  {
                    storeKey: 'prefillSource.testator.spouse',
                    operator: 'isEmpty',
                  },
                  {
                    answerKey: 'answerResponse.testator.spouseConfirmed',
                    operator: 'equals',
                    value: 'false',
                  },
                ],
              },
            ],
          },
          fields: [
            {
              id: 'firstName',
              fieldName: 'First name',
              inputType: 'text',
              validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid first name using letters only',
            },
            {
              id: 'middleName',
              fieldName: 'Middle name (optional)',
              inputType: 'text',
              validation: "^$|^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid middle name',
            },
            {
              id: 'lastName',
              fieldName: 'Last name',
              inputType: 'text',
              validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
              validationMessage: 'Enter a valid last name using letters only',
            },
            {
              id: 'dateOfBirth',
              fieldName: 'Date of birth (mm/dd/yyyy)',
              inputType: 'date',
              validation: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
              validationMessage: 'Enter a valid date in mm/dd/yyyy format',
              minAge: 18,
            },
            {
              id: 'email',
              fieldName: 'Email (optional)',
              inputType: 'email',
              validation: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
              validationMessage: 'Enter a valid email address',
            },
          ],
          requiredFields: ['firstName', 'lastName', 'dateOfBirth'],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_has_children',
          component: 'binaryChoice',
          bodyTitle: 'Do you${? and ${testator.spouse.firstName}} have any children?',
          bodySubtitle: 'Including minor, adult, adopted, and expected children.',
          answerKey: 'answerResponse.children.hasChildren',
          prefillSource: 'prefillSource.children.hasChildren',
          choices: [
            {
              label: 'No',
              value: 'false',
            },
            {
              label: 'Yes',
              value: 'true',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_children_list_with_prefill',
          component: 'itemList',
          bodyTitle: 'Are the children found on your account yours${? & ${testator.spouse.firstName}}?',
          bodySubtitle:
            'List all children, including minor and adult children, adopted children, and expected children.',
          answerKey: 'answerResponse.children.childrenList',
          prefillSource: 'prefillSource.children.childrenList',
          matchKey: 'fullName',
          savedOnlyOverflow: {
            editTrigger: 'modal_add_child',
            removeTrigger: 'remove',
          },
          showWhen: {
            operator: 'and',
            conditions: [
              {
                answerKey: 'answerResponse.children.hasChildren',
                operator: 'equals',
                value: 'true',
              },
              {
                storeKey: 'prefillSource.children',
                operator: 'notEmpty',
              },
            ],
          },
          items: [
            {
              type: 'repeated',
              dataField: 'children.childrenList',
              showIfEmpty: false,
              icon: 'person',
              title: '{item.fullName}',
              subtitle: '{item.dateOfBirth}',
              ctaTrigger: 'remove',
              ctaText: 'Remove',
              fields: [
                {
                  id: 'parentage',
                  fieldName: 'Who is this a child of?',
                  inputType: 'dropdown',
                  dropdownOptions: [
                    {
                      label: 'Me',
                      value: 'self',
                    },
                    {
                      label: '${testator.spouse.firstName} and I',
                      value: 'both',
                      showWhen: {
                        answerKey: 'answerResponse.testator.relationshipStatus',
                        operator: 'equals',
                        value: 'married',
                      },
                    },
                    {
                      label: 'Myself and someone else',
                      value: 'self_other',
                    },
                    {
                      label: '${testator.spouse.firstName} and someone else',
                      value: 'spouse_other',
                      showWhen: {
                        answerKey: 'answerResponse.testator.relationshipStatus',
                        operator: 'equals',
                        value: 'married',
                      },
                    },
                  ],
                },
              ],
              requiredFields: ['parentage'],
            },
          ],
          addButton: {
            label: 'Add child',
            ctaTrigger: 'modal_add_child',
          },
          validation: {
            minItems: 1,
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_children_list_no_prefill',
          component: 'itemList',
          bodyTitle: "Ok, let's get a little more info about your children",
          bodySubtitle:
            'List all children, including minor and adult children, adopted children, and expected children.',
          answerKey: 'answerResponse.children.childrenList',
          prefillSource: 'prefillSource.children.childrenList',
          matchKey: 'fullName',
          savedOnlyOverflow: {
            editTrigger: 'modal_add_child',
            removeTrigger: 'remove',
          },
          showWhen: {
            operator: 'and',
            conditions: [
              {
                answerKey: 'answerResponse.children.hasChildren',
                operator: 'equals',
                value: 'true',
              },
              {
                storeKey: 'prefillSource.children',
                operator: 'isEmpty',
              },
            ],
          },
          items: [
            {
              type: 'repeated',
              dataField: 'children.childrenList',
              showIfEmpty: false,
              icon: 'person',
              title: '{item.fullName}',
              subtitle: '{item.dateOfBirth}',
              fields: [
                {
                  id: 'parentage',
                  fieldName: 'Who is this a child of?',
                  inputType: 'dropdown',
                  dropdownOptions: [
                    {
                      label: 'Me',
                      value: 'self',
                    },
                    {
                      label: '${testator.spouse.firstName} and I',
                      value: 'both',
                      showWhen: {
                        answerKey: 'answerResponse.testator.relationshipStatus',
                        operator: 'equals',
                        value: 'married',
                      },
                    },
                    {
                      label: 'Myself and someone else',
                      value: 'self_other',
                    },
                    {
                      label: '${testator.spouse.firstName} and someone else',
                      value: 'spouse_other',
                      showWhen: {
                        answerKey: 'answerResponse.testator.relationshipStatus',
                        operator: 'equals',
                        value: 'married',
                      },
                    },
                  ],
                },
              ],
              requiredFields: ['parentage'],
            },
          ],
          addButton: {
            label: 'Add child',
            ctaTrigger: 'modal_add_child',
          },
          validation: {
            minItems: 1,
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_family_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of what we just covered.",
          card: {
            title: 'Personal & family',
            editNavigatesTo: 'step_confirm_info',
            rows: [
              {
                label: 'Full legal name',
                answerKey: 'answerResponse.testator.profile.name',
                text: '${testator.profile.name.firstName} ${testator.profile.name.lastName}',
              },
              {
                label: 'Primary address',
                answerKey: 'answerResponse.testator.profile.address',
                text: '${testator.profile.address.address}, ${testator.profile.address.state} ${testator.profile.address.zip}',
              },
              {
                label: 'Marital status',
                answerKey: 'answerResponse.testator.relationshipStatus',
                valueLabels: {
                  single: 'Single',
                  married: 'Married',
                  divorced: 'Divorced',
                  widowed: 'Widowed',
                },
              },
              {
                label: 'Spouse',
                answerKey: 'answerResponse.testator.spouse.fullName',
              },
              {
                label: 'Children',
                answerKey: 'answerResponse.children.childrenList',
                text: '${children.childrenList.fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_family_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const GUARDIANS_TEMPLATE = {
  sections: [
    {
      id: 'section_guardians',
      title: 'Guardians',
      showWhen: {
        answerKey: 'answerResponse.children.hasChildren',
        operator: 'equals',
        value: 'true',
      },
      steps: [
        {
          id: 'step_nominate_guardians',
          component: 'binaryChoice',
          bodyTitle: 'Do you want to nominate guardians for your children?',
          bodySubtitle:
            'Since your children are under 18, most people will nominate guardians to entrust care duties, including providing food, housing, education, and medical care if both legal parents are deceased.',
          answerKey: 'answerResponse.guardians.nominateGuardians',
          prefillSource: 'prefillSource.guardians.nominateGuardians',
          choices: [
            {
              label: 'No',
              value: 'false',
            },
            {
              label: 'Yes',
              value: 'true',
              subtitle: 'Most common',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_guardians_list',
          component: 'formCardList',
          bodyTitle: 'Who would you like to look after your children?',
          bodySubtitle: 'Only applies if both legal parents are deceased.',
          answerKey: 'answerResponse.guardians.guardians',
          prefillSource: 'prefillSource.guardians.guardians',
          showWhen: {
            answerKey: 'answerResponse.guardians.nominateGuardians',
            operator: 'equals',
            value: 'true',
          },
          card: {
            title: 'Guardian',
            additionalTitle: 'Backup guardian',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'guardian',
              additionalValue: 'successor_guardian',
            },
            fields: [
              {
                id: 'guardian_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add person',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a guardian',
            showWhenPrimaryFilled: true,
            ctaTrigger: 'modal_add_person_form',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_guardians_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of your guardians",
          bodySubtitle: 'Review the details below. Tap the edit button to make any changes.',
          card: {
            title: 'Guardians',
            editNavigatesTo: 'step_guardians_list',
            rows: [
              {
                label: 'Guardian',
                answerKey: 'answerResponse.guardians.guardians[0]',
                text: '${people[guardians.guardians.personId].fullName}',
              },
              {
                label: 'Backup guardian',
                answerKey: 'answerResponse.guardians.guardians[1:]',
                text: '${people[guardians.guardians.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_guardians_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const ASSETS_TEMPLATE = {
  sections: [
    {
      id: 'section_assets',
      title: 'Assets',
      steps: [
        {
          id: 'step_assets_list',
          component: 'itemList',
          bodyTitle: "Let's capture all of your assets",
          bodySubtitle:
            "We've pulled in existing assets based on your monitored info. Add additional assets or continue to the next step.",
          showWhen: {
            storeKey: 'inventory.assets.allAssets',
            operator: 'notEmpty',
          },
          footnotes: ['We never share your information with third parties'],
          answerKey: 'inventory.assets.allAssets',
          prefillSource: 'inventory.assets.allAssets',
          banner: {
            title: 'Funding your trust',
            subtitle: "Adding assets here doesn't fund your trust; that's a separate step.",
            showWhen: {
              storeKey: 'prefillSource.packageType',
              operator: 'equals',
              value: 'TRUST',
            },
          },
          items: [
            {
              type: 'databound',
              dataField: 'assets.allAssets.cashAccounts',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'bank',
              title: 'Cash accounts',
              tag: {
                fields: ['issuerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_cash_accounts',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.investments',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'line_graph',
              title: 'Investments',
              tag: {
                fields: ['issuerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_investments',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.realEstate',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'house',
              title: 'Real estate',
              tag: {
                fields: ['address', 'city'],
                separator: ', ',
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_real_estate',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.lifeInsurance',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'life_insurance',
              title: 'Life insurance',
              tag: {
                fields: ['insurerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_life_insurance',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.vehicles',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'vehicle',
              title: 'Vehicles',
              tag: {
                fields: ['make', 'model'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_vehicles',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.other',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'other',
              title: 'Other',
              tag: {
                fields: ['description'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_other',
            },
          ],
          validation: {
            minItems: 0,
            maxItems: 7,
          },
          zeroStateText: 'No assets listed',
          zeroStateIcon: 'illustration/home',
          addButton: {
            label: '+ Add',
            ctaTrigger: 'modal_add_asset_type',
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_assets_list_no_prefill',
          component: 'itemList',
          bodyTitle: "Let's capture all of your assets",
          showWhen: {
            storeKey: 'inventory.assets.allAssets',
            operator: 'isEmpty',
          },
          footnotes: ['We never share your information with third parties'],
          answerKey: 'inventory.assets.allAssets',
          prefillSource: 'inventory.assets.allAssets',
          banner: {
            title: 'Adding assets',
            subtitle: "Remember, adding assets here doesn't fund your trust; that's a separate step.",
            showWhen: {
              storeKey: 'prefillSource.packageType',
              operator: 'equals',
              value: 'TRUST',
            },
          },
          items: [
            {
              type: 'databound',
              dataField: 'assets.allAssets.cashAccounts',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'bank',
              title: 'Cash accounts',
              tag: {
                fields: ['issuerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_cash_accounts',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.investments',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'line_graph',
              title: 'Investments',
              tag: {
                fields: ['issuerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_investments',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.realEstate',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'house',
              title: 'Real estate',
              tag: {
                fields: ['address', 'city'],
                separator: ', ',
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_real_estate',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.lifeInsurance',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'life_insurance',
              title: 'Life insurance',
              tag: {
                fields: ['insurerName'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_life_insurance',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.vehicles',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'vehicle',
              title: 'Vehicles',
              tag: {
                fields: ['make', 'model'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_vehicles',
            },
            {
              type: 'databound',
              dataField: 'assets.allAssets.other',
              itemFilter: {
                field: 'enabled',
                operator: 'equals',
                value: true,
              },
              showIfEmpty: false,
              icon: 'other',
              title: 'Other',
              tag: {
                fields: ['description'],
              },
              ctaText: 'Review',
              ctaTrigger: 'modal_review_other',
            },
          ],
          validation: {
            minItems: 0,
            maxItems: 7,
          },
          zeroStateText: 'No assets listed',
          zeroStateIcon: 'illustration/home',
          addButton: {
            label: '+ Add',
            ctaTrigger: 'modal_add_asset_type',
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_assets_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of what we just covered",
          card: {
            title: 'Assets',
            editNavigatesTo: 'step_assets_list',
            rows: [
              {
                label: 'Bank account',
                answerKey: 'inventory.assets.allAssets.cashAccounts',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.cashAccounts.issuerName} • ${inventory.assets.allAssets.cashAccounts.accountType} • ${inventory.assets.allAssets.cashAccounts.last4}',
              },
              {
                label: 'Investments',
                answerKey: 'inventory.assets.allAssets.investments',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.investments.issuerName} • ${inventory.assets.allAssets.investments.last4}',
              },
              {
                label: 'Real estate',
                answerKey: 'inventory.assets.allAssets.realEstate',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.realEstate.address}, ${inventory.assets.allAssets.realEstate.city}, ${inventory.assets.allAssets.realEstate.state} ${inventory.assets.allAssets.realEstate.zip}',
              },
              {
                label: 'Life Insurance',
                answerKey: 'inventory.assets.allAssets.lifeInsurance',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.lifeInsurance.policyName}',
              },
              {
                label: 'Vehicle',
                answerKey: 'inventory.assets.allAssets.vehicles',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.vehicles.make} ${inventory.assets.allAssets.vehicles.model}',
              },
              {
                label: 'Other',
                answerKey: 'inventory.assets.allAssets.other',
                itemFilter: {
                  field: 'enabled',
                  operator: 'equals',
                  value: true,
                },
                text: '${inventory.assets.allAssets.other.itemName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_assets_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const BENEFICIARIES_TEMPLATE = {
  id: 'estate_planning_beneficiaries',
  sections: [
    {
      id: 'section_beneficiaries',
      title: 'Beneficiaries',
      steps: [
        {
          id: 'step_primary_beneficiaries',
          component: 'formCardList',
          bodyTitle: 'Who would you${? & ${store.spouse.firstName}} like to receive your assets?',
          answerKey: 'answerResponse.beneficiaries.primaryBeneficiaries',
          prefillSource: 'prefillSource.beneficiaries.primaryBeneficiaries',
          card: {
            title: 'Beneficiary name',
            additionalTitle: 'Beneficiary name',
            removeTrigger: 'remove',
            fields: [
              {
                id: 'beneficiary_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
              {
                id: 'beneficiary_percent',
                fieldName: 'Percent',
                answerKey: 'item.percentage',
                placeholder: '100%',
                inputType: 'text',
                width: 'third',
                validation: '^(?:100(?:\\.0{1,2})?|[1-9]\\d?(?:\\.\\d{1,2})?)(?:%)?$',
                validationMessage: 'Enter a valid percentage',
              },
            ],
          },
          addButton: {
            label: 'Add another beneficiary',
          },
          minEntries: 1,
          footer: {
            title: 'Total percent ${sum.percentage}%',
          },
          advanceRequirements: [
            {
              type: 'arrayFieldSum',
              field: 'percentage',
              equals: 100,
              message: 'Percentages must total 100%',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_backup_beneficiary_prompt',
          component: 'binaryChoice',
          bodyTitle: 'Would you like to designate a backup beneficiary?',
          bodySubtitle: 'Those who receive trust assets if all primary beneficiaries predecease you.',
          answerKey: 'answerResponse.beneficiaries.hasBackupBeneficiary',
          prefillSource: 'prefillSource.beneficiaries.hasBackupBeneficiary',
          choices: [
            {
              label: 'No',
              value: false,
            },
            {
              label: 'Yes',
              value: true,
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_backup_beneficiaries',
          component: 'formCardList',
          sectionTitle: 'Beneficiaries',
          bodyTitle: 'Who would you${? & ${store.spouse.firstName}} like as a backup beneficiary?',
          answerKey: 'answerResponse.beneficiaries.backupBeneficiaries',
          prefillSource: 'prefillSource.beneficiaries.backupBeneficiaries',
          showWhen: {
            answerKey: 'answerResponse.beneficiaries.hasBackupBeneficiary',
            operator: 'equals',
            value: 'true',
          },
          card: {
            title: 'Beneficiary name',
            additionalTitle: 'Beneficiary name',
            removeTrigger: 'remove',
            fields: [
              {
                id: 'backup_beneficiary_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
              {
                id: 'backup_beneficiary_percent',
                fieldName: 'Percent',
                answerKey: 'item.percentage',
                placeholder: '100%',
                inputType: 'text',
                width: 'third',
                validation: '^(?:100(?:\\.0{1,2})?|[1-9]\\d?(?:\\.\\d{1,2})?)(?:%)?$',
                validationMessage: 'Enter a valid percentage',
              },
            ],
          },
          addButton: {
            label: 'Add another backup',
          },
          minEntries: 1,
          footer: {
            title: 'Total percent ${sum.percentage}%',
          },
          advanceRequirements: [
            {
              type: 'arrayFieldSum',
              field: 'percentage',
              equals: 100,
              message: 'Percentages must total 100%',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_minimum_age_distribution',
          component: 'singleInput',
          bodyTitle:
            'What minimum age do you want ${people[beneficiaries.primaryBeneficiaries.personId].fullName} to receive their assets?',
          bodySubtitle:
            "This is the age they'll receive trust assets if all primary beneficiaries predecease you${? and ${store.spouse.firstName}}.",
          showWhen: {
            storeKey: 'prefillSource.packageType',
            operator: 'equals',
            value: 'TRUST',
          },
          answerKey: 'answerResponse.beneficiaries.minimumAgeDistribution',
          prefillSource: 'prefillSource.beneficiaries.minimumAgeDistribution',
          requiredFields: ['minimum_age_distribution'],
          field: {
            id: 'minimum_age_distribution',
            fieldName: 'Distribution age (min age must be 18)',
            inputType: 'text',
            validation: '^(1[89]|[2-9][0-9]|1[0-4][0-9]|150)$',
            validationMessage: 'Enter a valid age',
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_beneficiary_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of your beneficiary selections",
          card: {
            title: 'Beneficiaries',
            editNavigatesTo: 'step_primary_beneficiaries',
            rows: [
              {
                label: 'Beneficiary name',
                answerKey: 'answerResponse.beneficiaries.primaryBeneficiaries',
                text: '${beneficiaries.primaryBeneficiaries.percentage}% ${people[beneficiaries.primaryBeneficiaries.personId].fullName}',
              },
              {
                label: 'Backup beneficiary',
                answerKey: 'answerResponse.beneficiaries.backupBeneficiaries',
                text: '${beneficiaries.backupBeneficiaries.percentage}% ${people[beneficiaries.backupBeneficiaries.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_beneficiaries_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const TRUST_TEMPLATE = {
  id: 'estate_planning_trust',
  sections: [
    {
      id: 'section_trust',
      title: 'Trust',
      steps: [
        {
          id: 'step_trust_name',
          component: 'singleInput',
          bodyTitle: "Great! Let's give your trust a name",
          bodySubtitle:
            'Make it something personal or unique to you. This will appear on all your trust documentation.',
          answerKey: 'answerResponse.trust.name',
          prefillSource: 'prefillSource.trust.name',
          field: {
            id: 'trust_name',
            fieldName: 'Trust name',
            inputType: 'text',
            validation: '^.{1,120}$',
            validationMessage: 'Enter a valid trust name',
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_primary_trustee_intro',
          component: 'informational',
          bodyTitle:
            'Congrats! You${? and ${store.spouse.firstName}} will be the primary trustee of ${trust.name} trust',
          bodySubtitle:
            'As a primary trustee you have the responsibility of controlling everything in your trust. The primary trustee will hold the position until they are unable to do so, which usually happens when the primary trustee is deceased.',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_successor_trustee',
          component: 'formCardList',
          sectionTitle: 'Trustees',
          bodyTitle: 'Who would you${? and ${store.spouse.firstName}} like to nominate as a successor trustee?',
          bodySubtitle:
            'Successor trustee will handle your distribution and take care of your wishes after you${? and ${store.spouse.firstName}} are deceased.',
          answerKey: 'answerResponse.trust.trustees',
          prefillSource: 'prefillSource.trust.trustees',
          card: {
            title: 'Successor trustee',
            additionalTitle: 'Backup successor trustee',
            additionalBodyText:
              'This is an optional precaution that will only take effect if you${?, ${store.spouse.firstName},} and the successor trustee named above are all unavailable.',
            roleField: {
              id: 'role',
              primaryValue: 'successor_trustee',
              additionalValue: 'backup_successor_trustee',
            },
            removeTrigger: 'remove',
            fields: [
              {
                id: 'trustee_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup successor',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_trust_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of your trustee selections for ${trust.name}",
          card: {
            title: 'Trustees',
            editNavigatesTo: 'step_trust_name',
            rows: [
              {
                label: 'Trust',
                answerKey: 'answerResponse.trust.name',
              },
              {
                label: 'Primary trustees',
                answerKey: 'answerResponse.trust.primaryTrustees',
                text: '${people[trust.primaryTrustees.personId].fullName}',
              },
              {
                label: 'Successor trustee',
                answerKey: 'answerResponse.trust.trustees[0]',
                text: '${people[trust.trustees.personId].fullName}',
              },
              {
                label: 'Backup successor trustee',
                answerKey: 'answerResponse.trust.trustees[1:]',
                text: '${people[trust.trustees.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_trust_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const EXECUTOR_AND_POA_TEMPLATE = {
  id: 'estate_planning_pour_over_will',
  sections: [
    {
      id: 'section_pour_over_will',
      title: 'Executor & POA',
      steps: [
        {
          id: 'step_pour_over_executor_will',
          component: 'formCardList',
          bodyTitle: 'Who would you like to set as the will executor?',
          bodySubtitle: 'Manages the probate estate - files the will, pays debts.',
          showWhen: {
            storeKey: 'prefillSource.packageType',
            operator: 'equals',
            value: 'WILL',
          },
          answerKey: 'answerResponse.pourOverWill.executors',
          prefillSource: 'prefillSource.pourOverWill.executors',
          card: {
            title: 'Executor',
            additionalTitle: 'Backup executor',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'executor',
              additionalValue: 'successor_executor',
            },
            fields: [
              {
                id: 'executor_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_pour_over_executor_trust',
          component: 'formCardList',
          bodyTitle: "Now we'll setup your pour-over will and assign an executor",
          bodySubtitle:
            'The executor manages the probate estate — files the will, pays debts, then pours remaining assets into the trust.',
          showWhen: {
            storeKey: 'prefillSource.packageType',
            operator: 'equals',
            value: 'TRUST',
          },
          banner: {
            title: 'What is a pour-over will?',
            subtitle:
              "This acts as a will and covers any assets not mentioned in your trust. You'll need to assign an executor to manage assets and handle probate.",
          },
          answerKey: 'answerResponse.pourOverWill.executors',
          prefillSource: 'prefillSource.pourOverWill.executors',
          card: {
            title: 'Executor',
            additionalTitle: 'Backup executor',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'executor',
              additionalValue: 'successor_executor',
            },
            fields: [
              {
                id: 'executor_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_financial_poa',
          component: 'formCardList',
          bodyTitle: "Who should manage your finances if you can't?",
          bodySubtitle:
            'Your financial power of attorney can pay bills, manage accounts, and handle property on your behalf — choose someone you trust completely with money.',
          answerKey: 'answerResponse.financialPOA.poa',
          prefillSource: 'prefillSource.financialPOA.poa',
          card: {
            title: 'Power of attorney',
            additionalTitle: 'Backup power of attorney',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'primary_poa',
              additionalValue: 'successor_poa',
            },
            fields: [
              {
                id: 'poa_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
            showWhenPrimaryFilled: true,
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_pour_over_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of what we just covered",
          card: {
            title: 'Executor & POA',
            editNavigatesTo: 'step_pour_over_executor_will',
            rows: [
              {
                label: 'Executor',
                answerKey: 'answerResponse.pourOverWill.executors[0]',
                text: '${people[pourOverWill.executors.personId].fullName}',
              },
              {
                label: 'Backup executor',
                answerKey: 'answerResponse.pourOverWill.executors[1:]',
                text: '${people[pourOverWill.executors.personId].fullName}',
              },
              {
                label: 'Power of attorney',
                answerKey: 'answerResponse.financialPOA.poa[0]',
                text: '${people[financialPOA.poa.personId].fullName}',
              },
              {
                label: 'Backup power of attorney',
                answerKey: 'answerResponse.financialPOA.poa[1:]',
                text: '${people[financialPOA.poa.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_pour_over_will_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const HEALTH_TEMPLATE = {
  id: 'estate_planning_health',
  sections: [
    {
      id: 'section_health',
      title: 'Health',
      steps: [
        {
          id: 'step_healthcare_poa',
          component: 'formCardList',
          bodyTitle: "Who should make medical decisions if you can't?",
          bodySubtitle:
            "Your healthcare power of attorney speaks for you when you're unable to — choose someone who knows your wishes and can act under pressure.",
          answerKey: 'answerResponse.health.poa',
          prefillSource: 'prefillSource.health.poa',
          card: {
            title: 'Power of attorney',
            additionalTitle: 'Backup power of attorney',
            additionalBodyText: 'Your successor steps in only if your first choice is unavailable. You can name one.',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'primary_poa',
              additionalValue: 'successor_poa',
            },
            fields: [
              {
                id: 'poa_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
            showWhenPrimaryFilled: true,
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_life_sustaining_treatment',
          component: 'radioList',
          bodyTitle: 'Life-sustaining treatment preference',
          bodySubtitle:
            'Your wishes if you have a terminal condition or are in a persistent vegetative state. These drive the Advance Directive.',
          answerKey: 'answerResponse.health.lifeSustainingTreatment',
          prefillSource: 'prefillSource.health.lifeSustainingTreatment',
          options: [
            {
              value: 'all_treatment',
              title: 'I want all available life-sustaining treatment',
            },
            {
              value: 'no_prolonging',
              title: 'I do not want treatment that only prolongs dying',
            },
            {
              value: 'comfort_only',
              title: 'Comfort/palliative care only',
            },
            {
              value: 'agent_decides',
              title: 'Let my healthcare agent decide',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_organ_tissue_donation',
          component: 'radioList',
          bodyTitle: 'Organ and tissue donation preference',
          bodySubtitle: 'Your preference governs the Advance Directive and healthcare agent instructions.',
          answerKey: 'answerResponse.health.organDonationPreference',
          prefillSource: 'prefillSource.health.organDonationPreference',
          options: [
            {
              value: 'donate_all',
              title: 'Donate all organs and tissues',
            },
            {
              value: 'do_not_donate',
              title: 'Do not donate',
            },
            {
              value: 'agent_decides',
              title: 'Let my agent decide',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_medical_records_people',
          component: 'formCardList',
          bodyTitle: 'Who is authorized to access your medical records ',
          bodySubtitle:
            'Named individual who can receive protected health information for ${prefillSource.packageType} administration.',
          answerKey: 'answerResponse.health.authorizedPersons',
          prefillSource: 'prefillSource.health.authorizedPersons',
          card: {
            title: 'Health records access',
            additionalTitle: 'Additional person',
            removeTrigger: 'remove',
            fields: [
              {
                id: 'authorized_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add another person',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_health_summary',
          component: 'answerSummary',
          bodyTitle: "Here's a review of what we just covered",
          card: {
            title: 'Final arrangements & health',
            editNavigatesTo: 'step_healthcare_poa',
            rows: [
              {
                label: 'Power of attorney',
                answerKey: 'answerResponse.health.poa[0]',
                text: '${people[health.poa.personId].fullName}',
              },
              {
                label: 'Backup power of attorney',
                answerKey: 'answerResponse.health.poa[1:]',
                text: '${people[health.poa.personId].fullName}',
              },
              {
                label: 'Life-sustaining treatment preference',
                answerKey: 'answerResponse.health.lifeSustainingTreatment',
                valueLabels: {
                  all_treatment: 'I want all available life-sustaining treatment',
                  no_prolonging: 'I do not want treatment that only prolongs dying',
                  comfort_only: 'Comfort/palliative care only',
                  agent_decides: 'Let my healthcare agent decide',
                },
              },
              {
                label: 'Organ and tissue donation ',
                answerKey: 'answerResponse.health.organDonationPreference',
                valueLabels: {
                  donate_all: 'Donate all organs and tissues',
                  do_not_donate: 'Do not donate',
                  agent_decides: 'Let my agent decide',
                },
              },
              {
                label: 'Health records access',
                answerKey: 'answerResponse.health.authorizedPersons',
                text: '${people[health.authorizedPersons.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_health_section_review',
          component: 'sectionReview',
          bodyTitle: "All set. Let's build out your ${prefillSource.packageType} documents",
          reviewListTitle: 'Sections',
          showWhen: {
            operator: 'or',
            conditions: [
              {
                storeKey: 'prefillSource.packageType',
                operator: 'equals',
                value: 'WILL',
              },
              {
                operator: 'and',
                conditions: [
                  {
                    storeKey: 'prefillSource.packageType',
                    operator: 'equals',
                    value: 'TRUST',
                  },
                  {
                    answerKey: 'answerResponse.testator.spouse',
                    operator: 'isEmpty',
                  },
                ],
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_health_section_review_spouse',
          component: 'sectionReview',
          bodyTitle: "You're doing great! Next we're going to cover ${testator.spouse.firstName}'s details",
          reviewListTitle: 'Sections',
          showWhen: {
            operator: 'and',
            conditions: [
              {
                storeKey: 'prefillSource.packageType',
                operator: 'equals',
                value: 'TRUST',
              },
              {
                answerKey: 'answerResponse.testator.spouse',
                operator: 'notEmpty',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const SPOUSE_EXECUTOR_AND_POA_TEMPLATE = {
  id: 'estate_planning_spouse_pour_over_will',
  sections: [
    {
      id: 'section_spouse_pour_over_will',
      title: "Spouse's executor & POA",
      showWhen: {
        operator: 'and',
        conditions: [
          {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
          {
            storeKey: 'prefillSource.packageType',
            operator: 'equals',
            value: 'TRUST',
          },
        ],
      },
      steps: [
        {
          id: 'step_spouse_interstitial',
          component: 'informational',
          bodyTitle: "Before continuing, it's important you talk to ${testator.spouse.firstName} about their wishes",
          bodySubtitle: 'These are important decisions that your spouse should contribute to.',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_pour_over_executor',
          component: 'formCardList',
          bodyTitle: "Now we'll setup ${testator.spouse.firstName}'s pour-over will and assign an executor",
          bodySubtitle:
            'The executor manages the probate estate — files the will, pays debts, then pours remaining assets into the trust.',
          banner: {
            title: 'What is a pour-over will?',
            subtitle:
              'This acts as a will and covers any assets not mentioned in the trust. ${testator.spouse.firstName} needs to assign an executor to manage assets and handle probate.',
          },
          answerKey: 'answerResponse.spousePourOverWill.executors',
          prefillSource: 'prefillSource.spousePourOverWill.executors',
          card: {
            title: 'Executor',
            additionalTitle: 'Backup executor',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'executor',
              additionalValue: 'successor_executor',
            },
            fields: [
              {
                id: 'executor_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_financial_poa',
          component: 'formCardList',
          bodyTitle: "Who should manage ${testator.spouse.firstName}'s finances if they can't?",
          bodySubtitle:
            'Financial power of attorney can pay bills, manage accounts, and handle property on their behalf — choose someone they trust completely with money.',
          answerKey: 'answerResponse.spouseFinancialPOA.poa',
          prefillSource: 'prefillSource.spouseFinancialPOA.poa',
          card: {
            title: 'Power of attorney',
            additionalTitle: 'Backup power of attorney',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'primary_poa',
              additionalValue: 'successor_poa',
            },
            fields: [
              {
                id: 'poa_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
            showWhenPrimaryFilled: true,
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_pour_over_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of what we just covered",
          card: {
            title: "Spouse's executor & POA",
            editNavigatesTo: 'step_spouse_pour_over_executor',
            rows: [
              {
                label: 'Executor',
                answerKey: 'answerResponse.spousePourOverWill.executors[0]',
                text: '${people[spousePourOverWill.executors.personId].fullName}',
              },
              {
                label: 'Backup executor',
                answerKey: 'answerResponse.spousePourOverWill.executors[1:]',
                text: '${people[spousePourOverWill.executors.personId].fullName}',
              },
              {
                label: 'Power of attorney',
                answerKey: 'answerResponse.spouseFinancialPOA.poa[0]',
                text: '${people[spouseFinancialPOA.poa.personId].fullName}',
              },
              {
                label: 'Backup power of attorney',
                answerKey: 'answerResponse.spouseFinancialPOA.poa[1:]',
                text: '${people[spouseFinancialPOA.poa.personId].fullName}',
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_spouse_pour_over_will_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const SPOUSE_HEALTH_TEMPLATE = {
  id: 'estate_planning_spouse_health',
  sections: [
    {
      id: 'section_spouse_health',
      title: "Spouse's health",
      showWhen: {
        operator: 'and',
        conditions: [
          {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
          {
            storeKey: 'prefillSource.packageType',
            operator: 'equals',
            value: 'TRUST',
          },
        ],
      },
      steps: [
        {
          id: 'step_spouse_healthcare_poa',
          component: 'formCardList',
          bodyTitle: "Who should make medical decisions for ${testator.spouse.firstName} if they can't?",
          bodySubtitle:
            "Their healthcare power of attorney speaks for them when they're unable to — choose someone who knows their wishes and can act under pressure.",
          answerKey: 'answerResponse.spouseHealth.poa',
          prefillSource: 'prefillSource.spouseHealth.poa',
          card: {
            title: 'Power of attorney',
            additionalTitle: 'Backup power of attorney',
            additionalBodyText: 'Their successor steps in only if their first choice is unavailable. You can name one.',
            removeTrigger: 'remove',
            roleField: {
              id: 'role',
              primaryValue: 'primary_poa',
              additionalValue: 'successor_poa',
            },
            fields: [
              {
                id: 'poa_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add a backup',
            showWhenPrimaryFilled: true,
          },
          minEntries: 1,
          maxEntries: 2,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_life_sustaining_treatment',
          component: 'radioList',
          bodyTitle: "${testator.spouse.firstName}'s life-sustaining treatment preference",
          bodySubtitle:
            'Their wishes if they have a terminal condition or are in a persistent vegetative state. These drive the Advance Directive.',
          answerKey: 'answerResponse.spouseHealth.lifeSustainingTreatment',
          prefillSource: 'prefillSource.spouseHealth.lifeSustainingTreatment',
          options: [
            {
              value: 'all_treatment',
              title: 'I want all available life-sustaining treatment',
            },
            {
              value: 'no_prolonging',
              title: 'I do not want treatment that only prolongs dying',
            },
            {
              value: 'comfort_only',
              title: 'Comfort/palliative care only',
            },
            {
              value: 'agent_decides',
              title: 'Let my healthcare agent decide',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_organ_tissue_donation',
          component: 'radioList',
          bodyTitle: "${testator.spouse.firstName}'s organ and tissue donation preference",
          bodySubtitle: 'Their preference governs the Advance Directive and healthcare agent instructions.',
          answerKey: 'answerResponse.spouseHealth.organDonationPreference',
          prefillSource: 'prefillSource.spouseHealth.organDonationPreference',
          options: [
            {
              value: 'donate_all',
              title: 'Donate all organs and tissues',
            },
            {
              value: 'do_not_donate',
              title: 'Do not donate',
            },
            {
              value: 'agent_decides',
              title: 'Let my agent decide',
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_medical_records_people',
          component: 'formCardList',
          bodyTitle: "Who is authorized to access ${testator.spouse.firstName}'s medical records",
          bodySubtitle:
            'Named individuals who can receive protected health information for estate planning and trust administration.',
          answerKey: 'answerResponse.spouseHealth.authorizedPersons',
          prefillSource: 'prefillSource.spouseHealth.authorizedPersons',
          card: {
            title: 'Authorized person',
            additionalTitle: 'Additional person',
            removeTrigger: 'remove',
            fields: [
              {
                id: 'authorized_name',
                fieldName: 'Name',
                answerKey: 'item.personId',
                placeholder: 'Select',
                inputType: 'dropdown',
                optionsSource: 'answerSource.people',
                optionsMapping: {
                  label: {
                    fields: ['fullName'],
                  },
                  value: 'id',
                },
                addOption: {
                  label: 'Add Person',
                  icon: 'plus',
                  ctaTrigger: 'modal_add_person_form',
                },
              },
            ],
          },
          addButton: {
            label: 'Add another person',
          },
          minEntries: 1,
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_successor_trustee_medical_access',
          component: 'binaryChoice',
          bodyTitle:
            "Should the successor trustee be authorized to access ${testator.spouse.firstName}'s medical records?",
          bodySubtitle:
            'Enables the successor trustee to verify incapacity and activate their authority to manage the trust.',
          answerKey: 'answerResponse.spouseHealth.successorTrusteeMedicalAccess',
          prefillSource: 'prefillSource.spouseHealth.successorTrusteeMedicalAccess',
          choices: [
            {
              label: 'No',
              value: false,
            },
            {
              label: 'Yes',
              value: true,
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_medical_records_expiration',
          component: 'radioList',
          bodyTitle: "When should their access to ${testator.spouse.firstName}'s medical records expire?",
          bodySubtitle: 'Most trust HIPAA authorizations are indefinite or expire upon trust termination.',
          answerKey: 'answerResponse.spouseHealth.medicalRecordsExpiration',
          prefillSource: 'prefillSource.spouseHealth.medicalRecordsExpiration',
          options: [
            {
              value: 'no_expiration',
              title: 'No expiration (remains in effect until revoked)',
            },
            {
              value: 'trust_termination',
              title: 'Expires upon trust termination',
            },
            {
              value: 'settlor_death',
              title: "Expires upon settlor's death",
            },
          ],
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
        {
          id: 'step_spouse_health_summary',
          component: 'answerSummary',
          bodyTitle: "Ok, here's a review of what we just covered for ${testator.spouse.firstName}",
          card: {
            title: 'Final arrangements & health',
            editNavigatesTo: 'step_spouse_healthcare_poa',
            rows: [
              {
                label: 'Power of attorney',
                answerKey: 'answerResponse.spouseHealth.poa[0]',
                text: '${people[spouseHealth.poa.personId].fullName}',
              },
              {
                label: 'Backup power of attorney',
                answerKey: 'answerResponse.spouseHealth.poa[1:]',
                text: '${people[spouseHealth.poa.personId].fullName}',
              },
              {
                label: 'Life-sustaining treatment preference',
                answerKey: 'answerResponse.spouseHealth.lifeSustainingTreatment',
                valueLabels: {
                  all_treatment: 'I want all available life-sustaining treatment',
                  no_prolonging: 'I do not want treatment that only prolongs dying',
                  comfort_only: 'Comfort/palliative care only',
                  agent_decides: 'Let my healthcare agent decide',
                },
              },
              {
                label: 'Organ and tissue donation ',
                answerKey: 'answerResponse.spouseHealth.organDonationPreference',
                valueLabels: {
                  donate_all: 'Donate all organs and tissues',
                  do_not_donate: 'Do not donate',
                  agent_decides: 'Let my agent decide',
                },
              },
              {
                label: 'People with access to health records',
                answerKey: 'answerResponse.spouseHealth.authorizedPersons',
                text: '${people[spouseHealth.authorizedPersons.personId].fullName}',
              },
              {
                label: 'Access expiration',
                answerKey: 'answerResponse.spouseHealth.medicalRecordsExpiration',
                valueLabels: {
                  no_expiration: 'No expiration (remains in effect until revoked)',
                  trust_termination: 'Expires upon trust termination',
                  settlor_death: "Expires upon settlor's death",
                },
              },
            ],
          },
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Looks good',
          },
        },
        {
          id: 'step_spouse_health_section_review',
          component: 'sectionReview',
          bodyTitle: "You're doing great!",
          reviewListTitle: 'Sections',
          prevCta: {
            label: 'Back',
          },
          nextCta: {
            label: 'Continue',
          },
        },
      ],
    },
  ],
} as EstateTemplateBody;

export const MODALS_TEMPLATE = {
  modals: {
    modal_add_person_form: {
      id: 'modal_add_person_form',
      component: 'formModal',
      icon: 'person',
      title: 'Add person',
      fields: [
        {
          id: 'fullName',
          fieldName: 'Full legal name',
          inputType: 'text',
          validation: "^[A-Za-z][A-Za-z .'-]{1,}\\s+[A-Za-z][A-Za-z .'-]{1,}$",
          validationMessage: 'Enter a valid full name',
        },
        {
          id: 'relationship',
          fieldName: 'Relation to you${? or ${store.spouse.firstName}} (optional)',
          inputType: 'text',
        },
        {
          id: 'dateOfBirth',
          fieldName: 'Date of birth (optional)',
          inputType: 'date',
          validation: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
          validationMessage: 'Enter a valid date in mm/dd/yyyy format',
        },
        {
          id: 'email',
          fieldName: 'Email (optional)',
          inputType: 'email',
          validation: '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$',
          validationMessage: 'Enter a valid email address',
        },
      ],
      requiredFields: ['fullName'],
      ctaText: 'Add person',
    },
    modal_edit_name: {
      id: 'modal_edit_name',
      component: 'formModal',
      icon: 'person',
      title: 'Edit name',
      fields: [
        {
          id: 'firstName',
          fieldName: 'First name',
          inputType: 'text',
          validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
          validationMessage: 'Enter a valid first name',
        },
        {
          id: 'middleName',
          fieldName: 'Middle name (optional)',
          inputType: 'text',
          validation: "^$|^[A-Za-z][A-Za-z .'-]{1,}$",
          validationMessage: 'Enter a valid middle name',
        },
        {
          id: 'lastName',
          fieldName: 'Last name',
          inputType: 'text',
          validation: "^[A-Za-z][A-Za-z .'-]{1,}$",
          validationMessage: 'Enter a valid last name',
        },
      ],
      requiredFields: ['firstName', 'lastName'],
      ctaText: 'Update',
    },
    modal_edit_address: {
      id: 'modal_edit_address',
      component: 'formModal',
      icon: 'house',
      title: 'Edit address',
      fields: [
        {
          id: 'country',
          fieldName: 'Country',
          inputType: 'text',
          initialValue: 'United States',
          locked: true,
          validation: '^.{1,60}$',
          validationMessage: 'Enter a valid country name',
        },
        {
          id: 'address',
          fieldName: 'Address',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid street address',
        },
        {
          id: 'address2',
          fieldName: 'Address line 2 (apt, floor, etc)(Optional)',
          inputType: 'text',
          validation: '^.{0,120}$',
          validationMessage: 'Enter a valid address line',
        },
        {
          id: 'city',
          fieldName: 'City',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid city name',
        },
        {
          id: 'state',
          fieldName: 'State',
          width: 'half',
          inputType: 'dropdown',
          dropdownOptions: [
            'AL',
            'AK',
            'AZ',
            'AR',
            'CA',
            'CO',
            'CT',
            'DE',
            'DC',
            'FL',
            'GA',
            'HI',
            'ID',
            'IL',
            'IN',
            'IA',
            'KS',
            'KY',
            'LA',
            'ME',
            'MD',
            'MA',
            'MI',
            'MN',
            'MS',
            'MO',
            'MT',
            'NE',
            'NV',
            'NH',
            'NJ',
            'NM',
            'NY',
            'NC',
            'ND',
            'OH',
            'OK',
            'OR',
            'PA',
            'RI',
            'SC',
            'SD',
            'TN',
            'TX',
            'UT',
            'VT',
            'VA',
            'WA',
            'WV',
            'WI',
            'WY',
          ],
        },
        {
          id: 'zip',
          fieldName: 'Zip/Postal code',
          width: 'half',
          inputType: 'text',
          validation: '^[0-9a-zA-Z\\s\\-]{3,10}$',
          validationMessage: 'Enter a valid zip or postal code',
        },
      ],
      requiredFields: ['country', 'address', 'city', 'state', 'zip'],
      ctaText: 'Update',
    },
    modal_add_child: {
      id: 'modal_add_child',
      component: 'formModal',
      title: 'Add child',
      fields: [
        {
          id: 'fullName',
          fieldName: 'Full name',
          inputType: 'text',
          validation: "^[A-Za-z][A-Za-z .'-]{1,}\\s+[A-Za-z][A-Za-z .'-]{1,}$",
          validationMessage: 'Enter a valid full name',
        },
        {
          id: 'dateOfBirth',
          fieldName: 'Date of birth (mm/dd/yyyy)',
          inputType: 'date',
          validation: '^(0[1-9]|1[0-2])/(0[1-9]|[12][0-9]|3[01])/(19|20)\\d{2}$',
          validationMessage: 'Enter a valid date in mm/dd/yyyy format',
        },
        {
          id: 'parentage',
          fieldName: 'Who is this a child of?',
          inputType: 'radio',
          radioOptions: [
            {
              label: 'Me',
              value: 'self',
            },
            {
              label: '${testator.spouse.firstName} and I',
              value: 'both',
              showWhen: {
                answerKey: 'answerResponse.testator.relationshipStatus',
                operator: 'equals',
                value: 'married',
              },
            },
            {
              label: 'Myself and someone else',
              value: 'self_other',
            },
            {
              label: '${testator.spouse.firstName} and someone else',
              value: 'spouse_other',
              showWhen: {
                answerKey: 'answerResponse.testator.relationshipStatus',
                operator: 'equals',
                value: 'married',
              },
            },
          ],
        },
      ],
      requiredFields: ['fullName', 'dateOfBirth', 'parentage'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
    },
    modal_add_asset_type: {
      id: 'modal_add_asset_type',
      component: 'selectionModal',
      title: 'What asset would you like to add?',
      items: [
        {
          icon: 'house',
          title: 'Real estate',
          subtitle: 'Residential, commercial, land, or other',
          ctaText: 'Add',
          ctaTrigger: 'modal_add_real_estate',
        },
        {
          icon: 'bank',
          title: 'Account',
          subtitle: 'Checking, savings, or investment',
          ctaText: 'Add',
          ctaTrigger: 'modal_add_cash_account',
        },
        {
          icon: 'life_insurance',
          title: 'Life insurance',
          subtitle: 'Term, whole, universal, group, or other',
          ctaText: 'Add',
          ctaTrigger: 'modal_add_life_insurance',
        },
        {
          icon: 'vehicle',
          title: 'Vehicle',
          subtitle: 'Cars, boats, plane, or other',
          ctaText: 'Add',
          ctaTrigger: 'modal_add_vehicle',
        },
        {
          icon: 'other',
          title: 'Other',
          subtitle: 'Heirlooms, jewelry, artwork, or other',
          ctaText: 'Add',
          ctaTrigger: 'modal_add_other_asset',
        },
      ],
    },
    modal_add_cash_account: {
      id: 'modal_add_cash_account',
      component: 'formModal',
      title: 'Add the details of your account',
      fields: [
        {
          id: 'issuerName',
          fieldName: 'Financial institution',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid financial institution',
        },
        {
          id: 'last4',
          fieldName: 'Last 4 of account number',
          validation: '^[0-9]{4}$',
          validationMessage: 'Please enter a valid 4 digits',
          inputType: 'text',
        },
        {
          id: 'accountType',
          fieldName: 'Account type',
          placeholder: 'Select',
          inputType: 'dropdown',
          dropdownOptions: [
            'Checking',
            'Savings',
            'Money Market',
            'CD',
            'Brokerage',
            'IRA (Traditional)',
            'Roth IRA',
            '401(K)',
            '403(b)',
            'Credit Card',
            'Personal Loan',
            'Mortgage Loan',
            'Auto Loan',
            'Other',
          ],
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: '${testator.spouse.firstName}',
              value: 'owner_spouse',
            },
            {
              label: 'Me and ${testator.spouse.firstName}',
              value: 'owner_self_and_spouse',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
            {
              label: '${testator.spouse.firstName} and Others',
              value: 'owner_spouse_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'isEmpty',
          },
        },
      ],
      requiredFields: ['issuerName', 'last4', 'accountType', 'owner'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
      saveRouting: {
        fieldId: 'accountType',
        routes: [
          {
            values: ['Brokerage', 'IRA (Traditional)', 'Roth IRA', '401(K)', '403(b)'],
            answerKey: 'inventory.assets.allAssets.investments',
          },
          {
            default: true,
            answerKey: 'inventory.assets.allAssets.cashAccounts',
          },
        ],
      },
    },
    modal_add_real_estate: {
      id: 'modal_add_real_estate',
      component: 'formModal',
      title: 'Add the details of this real estate',
      fields: [
        {
          id: 'country',
          fieldName: 'Country',
          inputType: 'text',
          initialValue: 'United States',
          locked: true,
          validation: '^.{1,60}$',
          validationMessage: 'Enter a valid country name',
        },
        {
          id: 'address',
          fieldName: 'Address',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid street address',
        },
        {
          id: 'address2',
          fieldName: 'Address line 2 (apt, floor, etc)(Optional)',
          inputType: 'text',
          validation: '^.{0,120}$',
          validationMessage: 'Enter a valid address line',
        },
        {
          id: 'city',
          fieldName: 'City',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid city',
        },
        {
          id: 'state',
          fieldName: 'State',
          placeholder: 'Select',
          width: 'half',
          inputType: 'dropdown',
          dropdownOptions: [
            'AL',
            'AK',
            'AZ',
            'AR',
            'CA',
            'CO',
            'CT',
            'DE',
            'DC',
            'FL',
            'GA',
            'HI',
            'ID',
            'IL',
            'IN',
            'IA',
            'KS',
            'KY',
            'LA',
            'ME',
            'MD',
            'MA',
            'MI',
            'MN',
            'MS',
            'MO',
            'MT',
            'NE',
            'NV',
            'NH',
            'NJ',
            'NM',
            'NY',
            'NC',
            'ND',
            'OH',
            'OK',
            'OR',
            'PA',
            'RI',
            'SC',
            'SD',
            'TN',
            'TX',
            'UT',
            'VT',
            'VA',
            'WA',
            'WV',
            'WI',
            'WY',
          ],
        },
        {
          id: 'zip',
          fieldName: 'Zip/Postal code',
          width: 'half',
          inputType: 'text',
          validation: '^[0-9a-zA-Z\\s\\-]{3,10}$',
          validationMessage: 'Enter a valid zip or postal code',
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: '${testator.spouse.firstName}',
              value: 'owner_spouse',
            },
            {
              label: 'Me and ${testator.spouse.firstName}',
              value: 'owner_self_and_spouse',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
            {
              label: '${testator.spouse.firstName} and Others',
              value: 'owner_spouse_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'isEmpty',
          },
        },
      ],
      requiredFields: ['country', 'address', 'city', 'state', 'zip', 'owner'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
      saveRouting: {
        fieldId: 'address',
        routes: [
          {
            default: true,
            answerKey: 'inventory.assets.allAssets.realEstate',
          },
        ],
      },
    },
    modal_add_life_insurance: {
      id: 'modal_add_life_insurance',
      component: 'formModal',
      title: 'Add the details of your life insurance',
      fields: [
        {
          id: 'policyName',
          fieldName: 'Policy name',
          inputType: 'text',
          validation: '^.{0,120}$',
          validationMessage: 'Enter a valid policy name',
        },
        {
          id: 'insurerName',
          fieldName: 'Insurance provider',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid insurance provider',
        },
        {
          id: 'policyType',
          fieldName: 'Policy type',
          placeholder: 'Select',
          inputType: 'dropdown',
          dropdownOptions: [
            'Term life',
            'Whole life',
            'Universal life',
            'Variable life',
            'Group life (employer)',
            'Other',
          ],
        },
        {
          id: 'deathBenefitAmount',
          fieldName: 'Death benefit amount (optional)',
          inputType: 'text',
          validation: '^[0-9]{1,15}(\\.[0-9]{1,2})?$',
          validationMessage: 'Enter a valid death benefit amount',
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: '${testator.spouse.firstName}',
              value: 'owner_spouse',
            },
            {
              label: 'Me and ${testator.spouse.firstName}',
              value: 'owner_self_and_spouse',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
            {
              label: '${testator.spouse.firstName} and Others',
              value: 'owner_spouse_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'isEmpty',
          },
        },
      ],
      requiredFields: ['policyName', 'insurerName', 'policyType', 'owner'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
      saveRouting: {
        fieldId: 'policyName',
        routes: [
          {
            default: true,
            answerKey: 'inventory.assets.allAssets.lifeInsurance',
          },
        ],
      },
    },
    modal_add_vehicle: {
      id: 'modal_add_vehicle',
      component: 'formModal',
      title: 'Add the details of your vehicle',
      fields: [
        {
          id: 'make',
          fieldName: 'Make',
          inputType: 'text',
          validation: "^[A-Za-z0-9][A-Za-z0-9 .'-]{0,59}$",
          validationMessage: 'Enter a valid make',
        },
        {
          id: 'model',
          fieldName: 'Model',
          inputType: 'text',
          validation: "^[A-Za-z0-9][A-Za-z0-9 .'-]{0,59}$",
          validationMessage: 'Enter a valid model',
        },
        {
          id: 'licensePlate',
          fieldName: 'License plate number',
          inputType: 'text',
          validation: '^[^\\r\\n]{1,20}$',
          validationMessage: 'Enter a license plate (1–20 characters)',
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: '${testator.spouse.firstName}',
              value: 'owner_spouse',
            },
            {
              label: 'Me and ${testator.spouse.firstName}',
              value: 'owner_self_and_spouse',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
            {
              label: '${testator.spouse.firstName} and Others',
              value: 'owner_spouse_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'isEmpty',
          },
        },
      ],
      requiredFields: ['make', 'model', 'licensePlate', 'owner'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
      saveRouting: {
        fieldId: 'make',
        routes: [
          {
            default: true,
            answerKey: 'inventory.assets.allAssets.vehicles',
          },
        ],
      },
    },
    modal_add_other_asset: {
      id: 'modal_add_other_asset',
      component: 'formModal',
      title: 'Add the details of your Item',
      fields: [
        {
          id: 'itemName',
          fieldName: 'Item name',
          inputType: 'text',
          validation: '^.{1,120}$',
          validationMessage: 'Enter a valid item name',
        },
        {
          id: 'description',
          fieldName: 'Description',
          inputType: 'text',
          validation: '^.{0,120}$',
          validationMessage: 'Enter a valid description',
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: '${testator.spouse.firstName}',
              value: 'owner_spouse',
            },
            {
              label: 'Me and ${testator.spouse.firstName}',
              value: 'owner_self_and_spouse',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
            {
              label: '${testator.spouse.firstName} and Others',
              value: 'owner_spouse_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'notEmpty',
          },
        },
        {
          id: 'owner',
          fieldName: 'Owners',
          inputType: 'dropdown',
          dropdownOptions: [
            {
              label: 'Me',
              value: 'owner_self',
            },
            {
              label: 'Me and Others',
              value: 'owner_self_and_others',
            },
          ],
          showWhen: {
            answerKey: 'answerResponse.testator.spouse',
            operator: 'isEmpty',
          },
        },
      ],
      requiredFields: ['itemName', 'owner'],
      ctaText: 'Add to ${prefillSource.packageType}',
      ctaTrigger: 'save',
      saveRouting: {
        fieldId: 'itemName',
        routes: [
          {
            default: true,
            answerKey: 'inventory.assets.allAssets.other',
          },
        ],
      },
    },
    modal_review_cash_accounts: {
      id: 'modal_review_cash_accounts',
      component: 'reviewItemsModal',
      title: 'Cash accounts',
      icon: 'bank',
      prefillSource: 'inventory.assets.allAssets.cashAccounts',
      answerKey: 'inventory.assets.allAssets.cashAccounts',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['last4'],
        },
        subtitle: {
          fields: ['issuerName', 'accountType'],
          separator: ' · ',
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_cash_account',
        removeTrigger: 'remove',
      },
      addCta: {
        label: 'Add an account',
        ctaTrigger: 'modal_add_cash_account',
      },
    },
    modal_review_investments: {
      id: 'modal_review_investments',
      component: 'reviewItemsModal',
      title: 'Investments',
      icon: 'line_graph',
      prefillSource: 'inventory.assets.allAssets.investments',
      answerKey: 'inventory.assets.allAssets.investments',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['last4'],
        },
        subtitle: {
          fields: ['issuerName', 'accountType'],
          separator: ' · ',
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_cash_account',
        removeTrigger: 'remove',
      },
      addCta: {
        label: 'Add an account',
        ctaTrigger: 'modal_add_cash_account',
      },
    },
    modal_review_real_estate: {
      id: 'modal_review_real_estate',
      component: 'reviewItemsModal',
      title: 'Real estate',
      icon: 'house',
      prefillSource: 'inventory.assets.allAssets.realEstate',
      answerKey: 'inventory.assets.allAssets.realEstate',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['address', 'address2'],
        },
        subtitle: {
          fields: ['city', 'state', 'zip'],
          separator: ', ',
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_real_estate',
        removeTrigger: 'remove',
      },
    },
    modal_review_life_insurance: {
      id: 'modal_review_life_insurance',
      component: 'reviewItemsModal',
      title: 'Life insurance',
      icon: 'life_insurance',
      prefillSource: 'inventory.assets.allAssets.lifeInsurance',
      answerKey: 'inventory.assets.allAssets.lifeInsurance',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['policyName'],
        },
        subtitle: {
          fields: ['insurerName', 'policyType'],
          separator: ' · ',
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_life_insurance',
        removeTrigger: 'remove',
      },
    },
    modal_review_vehicles: {
      id: 'modal_review_vehicles',
      component: 'reviewItemsModal',
      title: 'Vehicles',
      icon: 'vehicle',
      prefillSource: 'inventory.assets.allAssets.vehicles',
      answerKey: 'inventory.assets.allAssets.vehicles',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['make', 'model'],
          separator: ' ',
        },
        subtitle: {
          fields: ['licensePlate'],
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_vehicle',
        removeTrigger: 'remove',
      },
    },
    modal_review_other: {
      id: 'modal_review_other',
      component: 'reviewItemsModal',
      title: 'Other',
      icon: 'other',
      prefillSource: 'inventory.assets.allAssets.other',
      answerKey: 'inventory.assets.allAssets.other',
      matchKey: 'id',
      displayFields: {
        title: {
          fields: ['itemName'],
        },
        subtitle: {
          fields: ['description'],
        },
      },
      savedOnlyOverflow: {
        editTrigger: 'modal_add_other_asset',
        removeTrigger: 'remove',
      },
    },
  },
} as EstateTemplateBody;

/** Map slug → parsed template body for composition. */
export const MOCK_TEMPLATE_SOURCES = {
  'about-you': ABOUT_YOU_TEMPLATE,
  family: FAMILY_TEMPLATE,
  guardians: GUARDIANS_TEMPLATE,
  assets: ASSETS_TEMPLATE,
  beneficiaries: BENEFICIARIES_TEMPLATE,
  trust: TRUST_TEMPLATE,
  'executor-and-poa': EXECUTOR_AND_POA_TEMPLATE,
  health: HEALTH_TEMPLATE,
  'spouse-executor-and-poa': SPOUSE_EXECUTOR_AND_POA_TEMPLATE,
  'spouse-health': SPOUSE_HEALTH_TEMPLATE,
  modals: MODALS_TEMPLATE,
} as const;
